import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'CreateDialog',

  mixins: [ proxy() ],

  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },

    OwnerId: String,

    loading: Boolean
  },

  data() {
    return {
      formValidation: false
    }
  },

  render
}
